import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import { SrIcon } from "@/components/ui/SrIcon";
import type { DrillStep } from "@/lib/reports/types";

export function ReportBreadcrumb({
  path,
  onJump,
  canGoBack = false,
  onBack,
}: {
  path: DrillStep[];
  onJump: (index: number) => void;
  canGoBack?: boolean;
  onBack?: () => void;
}) {
  return (
    <div className="flex items-center gap-3">
      {canGoBack && onBack && (
        <Button
          type="button"
          variant="ghost"
          size="sm"
          onClick={onBack}
          className="gap-1 text-muted-foreground"
        >
          <SrIcon name="chevron-left" />
          Tilbake
        </Button>
      )}

      <nav className="flex items-center gap-1 text-sm text-muted-foreground">
        {path.map((step, i) => {
          const isLast = i === path.length - 1;
          return (
            <span
              key={`${step.grain}:${step.id}`}
              className="flex items-center gap-1"
            >
              {i > 0 && (
                <SrIcon
                  name="chevron-right"
                  size={14}
                  className="text-muted-foreground/50"
                />
              )}
              {isLast ? (
                <span
                  aria-current="page"
                  className="font-medium text-foreground"
                >
                  {step.label}
                </span>
              ) : (
                <button
                  type="button"
                  onClick={() => onJump(i)}
                  className={cn(
                    "cursor-pointer underline-offset-4 transition-colors",
                    "hover:text-foreground hover:underline",
                  )}
                >
                  {step.label}
                </button>
              )}
            </span>
          );
        })}
      </nav>
    </div>
  );
}
